<template>
    <span v-if="appointment !== {}">
        <b-link
            v-if="
                appointment.is_active &&
                appointment.type.toUpperCase() == 'MEDICAL'
            "
            :to="{
                name: 'appointment',
                params: {
                    id: appointment.id,
                    view: 'resourceTimeGridDay',
                    start: appointment.sort_date
                }
            }"
            :target="appointment.openNewTab ? '_blank' : '_self'"
        >
            {{ text || _setDateTimeDisplay(appointment.start) }}
        </b-link>
        <b-link
            v-else-if="
                appointment.is_active &&
                appointment.type.toUpperCase() == 'BOARDING'
            "
            :to="{
                name: 'boarding.reservations'
            }"
        >
            {{ text || _setDateTimeDisplay(appointment.start) }}
        </b-link>
        <span v-else>
            {{ text || _setDateTimeDisplay(appointment.start) }}
        </span>
    </span>
</template>

<script>
import { DateTime } from "luxon";

export default {
    name: "appointmentDate",
    props: {
        appointment: {
            type: Object,
            required: true,
            default: () => {}
        },
        /**
         * text: label shown. if not specified, formatted date will be used
         */
        text: {
            default: null
        }
    }
};
</script>
